import React from 'react';


export const TabContent = ({children}) => {
  return (
    <React.Fragment>
      {children}
    </React.Fragment>
  )
}